import { Component,Inject, OnDestroy } from "@angular/core";
import { FormGroup,FormBuilder,Validators} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { UserService } from "../../shared/services/user/user.service";
import { DashboardService } from "../../shared/services/dashboard/dashboard.service";
import { Dashboard } from "../../shared/interface/dashboard";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

// edit dashboard name
@Component({
  selector: "edit-dashboard",
  templateUrl: "edit-dashboard.dialog.html"
})
export class EditDashboardDialog implements OnDestroy{
  dashboardForm: FormGroup;
  isSubmitted: number = 0;
  isDefaultDashboard: boolean = false;
  user: any;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    private dashboardService: DashboardService,
    private userService: UserService,
    public dialogRef: MatDialogRef<EditDashboardDialog>
  ) {
    data = this.parseData(data);

    this.user = this.userService.getLoggedInUser();
    if (this.user.defaultDashboard == data.dashboardId) {
      this.isDefaultDashboard = true;
    }

    this.createForm(data);

  }

  createForm(data: Dashboard) {
    this.dashboardForm = this.fb.group({
      dashboardId: data.dashboardId,
      dashboardName: [data.dashboardName, Validators.required],
      setDefaultDashboard: [this.isDefaultDashboard]
    });
  }

  parseData(data: any) {
    if (data && data.dashboardId) {
      return data;
    }
    return {
      dashboardId: "",
      dashboardName: ["", Validators.required],
      setDefaultDashboard: [false]
    };
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onSubmit(form: any) {
    if (!this.dashboardForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    this.dashboardService.update(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.dialogRef.close();
        this.dashboardService.sendAction("updateName", form.dashboardName);
        this.isSubmitted = 0;

        let data = undefined;
        if (form.setDefaultDashboard) {
          data = { defaultDashboardName: form.dashboardName, defaultDashboard: form.dashboardId };
        }
        if (this.user.defaultDashboard == form.dashboardId && !form.setDefaultDashboard) {
          data = { defaultDashboardName: "", defaultDashboard: "" };
        }
        if (data) {
          this.userService.savePersonalDetailsToToken(data);
        }

      },
      err => {
        this.isSubmitted = 0;
      }
    );
  }

  blockNumbers(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 64 && charCode < 91) || charCode == 8 || charCode == 32 || charCode == 189 || charCode == 37 || charCode == 39) {
      return true;
    }
    else {
      return false;
    }
  }
}




// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/private-dashboard/editDashboard/edit-dashboard.dialog.ts